export function canUseTicketCannedReplies(accessState = {}) {
    return !!accessState.isAdmin || !!accessState.isServiceProvider;
}

export function isExternalTicketViewer(accessState = {}) {
    return !!accessState.isGuest || !!accessState.isCustomer;
}

export function canManageTicketStatus(accessState = {}) {
    return !isExternalTicketViewer(accessState);
}

export function canManageTicketTopic(accessState = {}) {
    return !accessState.isGuest;
}

export function canManageTicketLabels(accessState = {}) {
    return !accessState.isGuest;
}

export function canViewTicketLabels(accessState = {}) {
    return canManageTicketLabels(accessState);
}

export function canViewTicketPriority(accessState = {}) {
    return !isExternalTicketViewer(accessState);
}

export function showTicketApprovalTabs(accessState = {}) {
    return !accessState.isServiceProvider || !!accessState.isAdmin;
}

export function canSetNewTicketStatus(accessState = {}, overrideValue = null) {
    if (overrideValue !== null) {
        return !!overrideValue;
    }

    return !accessState.isGuest && !accessState.isServiceProvider;
}

export function canSetNewTicketPriority(accessState = {}, overrideValue = null) {
    if (overrideValue !== null) {
        return !!overrideValue;
    }

    return !accessState.isGuest && !accessState.isServiceProvider;
}

export function canSelectNewTicketProject(accessState = {}, projectCount = 0) {
    return projectCount > 0 && (accessState.isAdmin || accessState.isCustomer || accessState.isServiceProvider);
}
